// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  partner/src/context/AuthContext.jsx
//  Copy to: C:\quickry\partner\src\context\AuthContext.jsx
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [vendor,     setVendor]     = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading,    setLoading]    = useState(true);

  useEffect(() => {
    const token  = localStorage.getItem("partner_token");
    const saved  = localStorage.getItem("partner_vendor");
    if (token && saved) {
      try {
        setVendor(JSON.parse(saved));
        setIsLoggedIn(true);
      } catch { }
    }
    setLoading(false);
  }, []);

  const login = (vendorData, token) => {
    localStorage.setItem("partner_token",  token);
    localStorage.setItem("partner_vendor", JSON.stringify(vendorData));
    setVendor(vendorData);
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem("partner_token");
    localStorage.removeItem("partner_vendor");
    setVendor(null);
    setIsLoggedIn(false);
  };

  const getToken = () => localStorage.getItem("partner_token") || "";

  return (
    <AuthContext.Provider value={{ vendor, isLoggedIn, loading, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}